import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import FreeBets from "./pages/FreeBets";
import Vip from "./pages/Vip";
import AboutUs from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Subscription from "./pages/Subscription";
import NewResult from "./pages/NewResult";
import NewArticle from "./pages/NewArticle";
import Articles from "./pages/Articles";
import ArticleAnalysis from "./pages/ArticleAnalysis";
import ScrollToTop from "./tools/ScrollToTop";
import Statistics from "./pages/Statistics";
import Traffic from "./pages/Traffic";
import { LanguageProvider } from "./tools/LanguageContext";
//import Poker from "./pages/Poker";

function App() {
  return (
    <LanguageProvider>
      <Router basename="/">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/free_bets" element={<FreeBets />} />
          <Route path="/vip" element={<Vip />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/new_result" element={<NewResult />} />
          <Route path="/new_article" element={<NewArticle />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/traffic" element={<Traffic />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/article_analysis/:articleId" element={<ArticleAnalysis />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
